import axios from "axios";

const Api = axios.create({
  baseURL: "https://campusvirtualapas.com.br/api/",
});

export default Api;